/**
 * Generate an array of numbers from 1 to n.
 * @param {number} n The desired length of the array.
 * @returns {number[]} An array of numbers from 1 to n.
 */
const generateArray = (n) => {
  return Array.from({ length: n }, (_, i) => i + 1);
};

export default generateArray;
